import { SampleGenNewLayer, type SampleGenState } from "@wbaudio/core/synth";

export interface ShushPreset {
  id: string;
  name: string;
  state: SampleGenState;
}

export const ShusherLoopId = "shusher-loop";

function ShusherLoopState(): SampleGenState {
  const wind = SampleGenNewLayer([], "wind", { bed: true, opts: { "wind/duration": 5 } });
  const shush = SampleGenNewLayer([wind], "shush", {
    timing: { type: "at", at: [1, 3] },
    stop: 1.5,
  });
  return { length: 5, sampleRate: 44100, gain: 1, layers: [wind, shush], fx: [] };
}

export const ShusherLoopDefaults: SampleGenState = ShusherLoopState();

export function ShusherLoopPreset(): ShushPreset {
  return { id: ShusherLoopId, name: "shusher loop", state: structuredClone(ShusherLoopDefaults) };
}

export function SameSampleState(a: SampleGenState, b: SampleGenState) {
  return JSON.stringify(a) === JSON.stringify(b);
}

//#region preset store
const PresetsStorageKey = "shushgen:presets";

export interface ShushStored {
  active: string;
  volume: number;
  presets: Record<string, ShushPreset>;
}

export function LoadShushStored(): ShushStored {
  let saved: Partial<ShushStored> = {};
  try {
    saved = JSON.parse(localStorage.getItem(PresetsStorageKey) ?? "{}");
  } catch {
    saved = {};
  }
  const presets = saved.presets ?? {};
  const active = saved.active && presets[saved.active] ? saved.active : ShusherLoopId;
  if (!presets[active]) presets[active] = ShusherLoopPreset();
  return { active, volume: saved.volume ?? 1, presets };
}

export function SaveShushStored(stored: ShushStored) {
  try {
    localStorage.setItem(PresetsStorageKey, JSON.stringify(stored));
  } catch {
    return;
  }
}
//#endregion

//#region loop store
const LoopCacheName = "shushgen-loops";

function LoopUrl(id: string) {
  return new URL(`loops/${encodeURIComponent(id)}.wav`, document.baseURI).href;
}

export async function LoadLoop(id: string): Promise<Blob | null> {
  if (typeof caches === "undefined") return null;
  const cache = await caches.open(LoopCacheName);
  const res = await cache.match(LoopUrl(id));
  return res ? await res.blob() : null;
}

export async function SaveLoop(id: string, blob: Blob): Promise<void> {
  if (typeof caches === "undefined") return;
  const cache = await caches.open(LoopCacheName);
  await cache.put(LoopUrl(id), new Response(blob, { headers: { "Content-Type": blob.type } }));
}
//#endregion
